import { CityLocation, CityLocationsArray } from "@app/data/location/schema";
import { ListChildComponentProps } from "react-window";
import { ListItem, ListItemButton, ListItemText } from "@mui/material";

export function rowBuilder(
  callback: (city: CityLocation) => void,
  fallbackData: CityLocation[]
) {
  return function renderRow(
    props: ListChildComponentProps<CityLocationsArray | undefined>
  ) {
    const { index, style, data } = props;

    // Используем fallbackData, если data пусто или не существует
    const effectiveData = data && data.length > 0 ? data : fallbackData;
    const element = effectiveData[index];
    const { city: title } = element ?? { city: "" };

    return (
      <ListItem style={style} key={index} component="div" disablePadding>
        <ListItemButton onClick={() => callback(element!!)}>
          <ListItemText primary={title} />
        </ListItemButton>
      </ListItem>
    );
  };
}
